export const TELEMETRY_SCHEMA = 1
export const TELEMETRY_PRODUCT = 'payload-storage-bunny'
export const TELEMETRY_ENDPOINT = 'https://telemetry.seshuk.im/v1/collect'
export const TELEMETRY_TIMEOUT_MS = 2000
export const TELEMETRY_DOCS_URL = 'https://payload-storage-bunny.seshuk.im/configuration/telemetry'
